import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ExportFormatSelector = ({ selectedFormat, onChange }) => {
  const formats = [
    {
      value: 'pdf',
      label: 'PDF Executive Summary',
      description: 'Board-ready report with PNG Kina formatting',
      icon: 'FileText'
    },
    {
      value: 'excel',
      label: 'Excel Workbook',
      description: 'Detailed data with multiple sheets',
      icon: 'Table'
    },
    {
      value: 'powerpoint',
      label: 'PowerPoint Presentation',
      description: 'Presentation template with charts',
      icon: 'Presentation'
    },
    {
      value: 'csv',
      label: 'CSV Data Export',
      description: 'Raw data for external analysis',
      icon: 'Database'
    }
  ];

  const selectedFormatDetails = formats?.find(f => f?.value === selectedFormat);

  return (
    <div>
      <label className="block text-sm font-medium text-foreground mb-3">
        Export Format
      </label>

      <Select
        value={selectedFormat}
        onChange={(e) => onChange(e?.target?.value)}
        options={formats?.map(f => ({
          value: f?.value,
          label: f?.label,
          description: f?.description
        }))}
      />

      {selectedFormatDetails && (
        <div className="mt-3 p-3 bg-muted/30 rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name={selectedFormatDetails?.icon} size={16} color="var(--color-primary)" />
            <div>
              <p className="text-xs font-medium text-foreground mb-1">
                {selectedFormatDetails?.label}
              </p>
              <p className="text-xs text-muted-foreground">
                {selectedFormatDetails?.description}
              </p>
            </div>
          </div>
        </div>
      )}

      <div className="mt-3 p-2 bg-success/10 rounded-md flex items-start gap-2">
        <Icon name="Check" size={14} color="var(--color-success)" className="mt-0.5" />
        <p className="text-xs text-success">
          All exports include PNG Kina (K) currency formatting
        </p>
      </div>
    </div>
  );
};

export default ExportFormatSelector;